import { render } from "./ChooseDirectoryModal.vue?vue&type=template&id=0796f6ae&scoped=true"
import script from "./ChooseDirectoryModal.vue?vue&type=script&lang=ts"
export * from "./ChooseDirectoryModal.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-0796f6ae"

export default script